module.exports = __webpack_public_path__ + "static/media/login-bg.7306e4ed.jpg";